import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Preset.module.scss";
import SelectUser from "./selectUser/SelectUser";
import PresetTest from "./presetTest/PresetTest";
import Axios from "../../../_services/caller.service";
import PresetCr from "./presetCr/PresetCr";

const Preset = () => {
  const [allUser, setAllUser] = useState([]);
  const [userId, setUserId] = useState("");
  const [overlay, setOverlay] = useState(false);
  const [searchUser, setSearchUser] = useState("");
  const [isSearchingUser, setIsSearchingUser] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    Axios.get(`/getAllUserForSuperAdmin`)
      .then(function async(response) {
        setAllUser(response.data.data);
      })
      .catch(function (error) {
        // console.log(error);
      });
  }, []);

  const changeUserIdWithSelect = (e) => {
    const id = e.target.value;
    setUserId(id);
    setSearchUser("");
  };

  return (
    <div className={styles.container}>
      {overlay && <div className={styles.overlay}></div>}

      <div className={styles.header}>
        <h2>{t("preset.configuration_preset")}</h2>
        <div className={styles.actions}>
          <SelectUser
            allUser={allUser}
            changeUserIdWithSelect={changeUserIdWithSelect}
            searchUser={searchUser}
            setSearchUser={setSearchUser}
            userId={userId}
            isSearchingUser={isSearchingUser}
            setIsSearchingUser={setIsSearchingUser}
          />
        </div>
      </div>

      {userId ? (
        <div className={styles.content}>
          <div className={styles.section}>
            <PresetTest userId={userId} setOverlay={setOverlay} />
          </div>
          <div className={styles.section}>
            <PresetCr userId={userId} setOverlay={setOverlay} />
          </div>
        </div>
      ) : (
        <p className={styles.emptyState}>
          {t("preset.select_user_for_presets")}
        </p>
      )}
    </div>
  );
};

export default Preset;
